import { Breakpoint } from '@mui/material/styles';
import { useContext } from 'react';

import { ModalContext, ModalRenderer } from '../components/Modal/ModalContextProvider';

export type DispatchProps<P> = keyof Omit<P, 'handleClose'> extends never ? void : Omit<P, 'handleClose'>;

export interface ModalContextProps {
  size?: Breakpoint;
}

function useModalDispatch<P>(
  component: ModalRenderer<P>,
  contextProps?: ModalContextProps,
): (props: DispatchProps<P>, pathname?: string | null) => void;
function useModalDispatch(component: undefined, contextProps?: ModalContextProps): undefined;
function useModalDispatch<P>(
  component: ModalRenderer<P> | undefined,
  contextProps?: ModalContextProps,
): (props: DispatchProps<P>, pathname?: string | null) => void | undefined;
function useModalDispatch<P>(component: ModalRenderer<P> | undefined, contextProps?: ModalContextProps) {
  const [setModal] = useContext(ModalContext) as ModalContext<P>;

  if (!component) {
    return undefined;
  }

  return (componentProps: DispatchProps<P>, pathname?: string | null) => {
    setModal([component, componentProps, contextProps, pathname]);
  };
}

export default useModalDispatch;
